import type { UnconfiguredGuests } from '~/domains/booking';
import { useHotelStore } from '~/domains/hotel';
import { extractDateFromApiString } from '~/helpers';
import { DefaultStayDates } from '~/domains/hotel/constants';

export function useHotelSearchBarValues() {
  const hotelStore = useHotelStore();

  const dates = computed({
    get: () => hotelStore.dates || [],
    set: (value: Date[]) => hotelStore.setDates(value),
  });
  const roomsAndGuests = computed({
    get: () => hotelStore.rooms,
    set: (value: UnconfiguredGuests[]) => hotelStore.setRooms(value),
  });

  if (!(dates.value.length && roomsAndGuests.value.length)) {
    const route = useRoute();

    let rawDates: Date[] = [];
    let rawRoomsAndGuests: UnconfiguredGuests[] = [];

    if (route.query.dates) {
      const [rawFirstDate, rawLastDate] = JSON.parse(
        route.query.dates as string,
      );

      rawDates = [
        extractDateFromApiString(rawFirstDate),
        extractDateFromApiString(rawLastDate),
      ];
    } else {
      const firstDate = new Date();
      firstDate.setDate(
        firstDate.getDate() + DefaultStayDates.DayToAddFromToday,
      );

      const lastDate = new Date(firstDate);
      lastDate.setDate(
        lastDate.getDate() + DefaultStayDates.StayDurationInDays,
      );

      rawDates = [firstDate, lastDate];
    }

    if (route.query.roomsAndGuests) {
      rawRoomsAndGuests = JSON.parse(route.query.roomsAndGuests as string);
    }

    dates.value = rawDates;
    roomsAndGuests.value = rawRoomsAndGuests;
  }

  return { dates, roomsAndGuests };
}
